import React, { createContext, useState } from "react";

export const SearchVisitContext = createContext({});

export const initialSearchValues = {
  yearOfBudget: "",
  month: "",
  lineOfWork: "",
  estateId: "",
};

export const initialPageValues = {
  page: 0,
  pageSize: 10,
  total: 0,
  totalPage: 0,
  sortBy: "createDate",
  sortDirection: "DESC",
};

const SearchVisitProvider = ({ children }) => {
  const [searchValues, setSearchValues] = useState(initialSearchValues);
  const [pageValues, setPageValues] = useState(initialPageValues);
  const [search, setSearch] = useState(true);

  return (
    <SearchVisitContext.Provider
      value={{
        searchValues,
        setSearchValues,
        pageValues,
        setPageValues,
        search,
        setSearch,
      }}
    >
      {children}
    </SearchVisitContext.Provider>
  );
};

export default SearchVisitProvider;
